(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // controller for agenda appointment modifications 
    module.controller('AgendaAppointmentsModificationsModalController',
        ['appointment','modifications', '$uibModalInstance', AgendaAppointmentsModificationsModalControllerFn]);

    function AgendaAppointmentsModificationsModalControllerFn(appointment,modifications, $uibModalInstance) {
        var vm = this;

        // list of modifications
        vm.modifications = [];
        vm.appointment = null;

        activate();

        // activation work
        function activate() {
            vm.modifications = modifications;
            vm.appointment = appointment;
        } // activate

        vm.close = function() {
            $uibModalInstance.close();
        };
    }

})();